module.exports = __webpack_public_path__ + "img/邻里2.c7db2233.png";